import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, Info, X } from 'lucide-angular';

@Component({
  selector: 'app-sunset-banner',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './sunset-banner.component.html',
  styleUrl: './sunset-banner.component.scss',
})
export class SunsetBannerComponent {
  Info = Info;
  X = X;

  // Check if banner was previously dismissed
  isDismissed = signal<boolean>(this.getBannerDismissalState());

  dismissBanner() {
    this.isDismissed.set(true);
    // Store dismissal state in localStorage for 30 days
    const dismissalExpiry = Date.now() + 30 * 24 * 60 * 60 * 1000; // 30 days from now
    localStorage.setItem('sunset-banner-dismissed-v2', dismissalExpiry.toString());
  }

  private getBannerDismissalState(): boolean {
    const dismissed = localStorage.getItem('sunset-banner-dismissed-v2');
    if (!dismissed) return false;

    const dismissalExpiry = parseInt(dismissed, 10);
    if (Date.now() > dismissalExpiry) {
      localStorage.removeItem('sunset-banner-dismissed-v2');
      return false;
    }

    return true;
  }
}
